import React from 'react';
import { Link } from 'react-router-dom';

const NotAllowedPage = () => (
  <div className="page-notallowed bhp-padding-4x">
    <h3>
      You do not have the necessary permissions to view this page (403)
    </h3>
    <span>
      <Link to="/">
        <span>
          Go back to home
        </span>
      </Link>
    </span>
  </div>
);

export default NotAllowedPage;
